// extracted by mini-css-extract-plugin
export default {"cardsWrap":"QueueSidePanel_cardsWrap__mrG18"};